/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Xray_DisableInputs */

const en_xray_disable = /** @type {(inputs: Xray_DisableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide robots behind walls`)
};

const fr_xray_disable = /** @type {(inputs: Xray_DisableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masquer les robots derrière les murs`)
};

const ms_sg2_xray_disable = /** @type {(inputs: Xray_DisableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sembunyikan robot di belakang dinding`)
};

/**
* | output |
* | --- |
* | "Hide robots behind walls" |
*
* @param {Xray_DisableInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const xray_disable = /** @type {((inputs?: Xray_DisableInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Xray_DisableInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_xray_disable(inputs)
	if (locale === "fr") return fr_xray_disable(inputs)
	return ms_sg2_xray_disable(inputs)
});